import React from "react"
import "./Portfolio.css"
import digital from "./portfolioimage/digital.jpg"
import gits from "./portfolioimage/gits.jpg"
import imperia from "./portfolioimage/imperia.jpg"
import foto from "./portfolioimage/foto.jpg"

const Portfolio = () => {
  return (
    <>
      <section className='Portfolio top' id='portfolio'>
        <div className='container'>
          <div className='heading text-center '>
          <h2 className='my-p'>My Portfolio</h2>
          </div>
          
          <div className='portfolios'>
            <div className='box_p'>
                <a href="https://01werka-digitalflow.netlify.app/" target="_blank">
                    <img className='digital' src={digital} alt="" />
                    <button className='portfolio1-btn'>Digital flow</button>
                </a>
                
                
                
            </div>

            <div className='box_p'>
                <a href="https://01werka-gitsuz.netlify.app/" target="_blank">
                    <img className='digital' src={gits} alt="" />
                    <button className='portfolio1-btn'>gits.uz</button>
                </a>
                
                
                
            </div>

            <div className='box_p'>
                <a href="https://01werka-imperia.netlify.app/" target="_blank">
                    <img className='digital' src={imperia} alt="" />
                    <button className='portfolio1-btn'>Imperia</button>
                </a>
                
                
                
            </div>

            <div className='box_p'>
                <a href="https://werka-foto-site.netlify.app/" target="_blank">
                    <img className='digital' src={foto} alt="" />
                    <button className='portfolio1-btn'>Simple Foto</button>
                </a>
                
                
            </div>
        </div>

          {/* <div className='content grid'>
            {Portfolio_data.map((value, index) => {
              return <Card key={index} image={value.image} category={value.category} totalLike={value.totalLike} title={value.title} />
            })}

            <div className='box btn_shadow '>
              <div className='img'>
                  <img src='https://rainbowit.net/html/inbio/assets/images/portfolio/portfolio-01.jpg' alt='' />
              </div>
              <div className='category d_flex'>
                  <span>Development</span>
                  <label>
                    <i className='far fa-heart'></i> 360
                  </label>
              </div>
              <div className='title'>
                  <h2>Mobile app landing design & Services</h2>
                <a href='' className='arrow'>
                  <i class='fas fa-arrow-right'></i>
                </a>
              </div>
            </div>
          </div> */}
        </div>
      </section>
      
    </>
  )
}

export default Portfolio
